/**
 * Created by hao.cheng on 2017/5/7.
 */
import React from 'react';
import {Icon,Modal} from 'antd';
import styled from "styled-components";
import {Button} from "antd";
import Iconfont from "../components/Iconfont/Iconfont";


const AMFContent = styled.div`
    // background-color: #fff;
    // padding: 20px 15px;
    // height:calc(100vh - 80px);
    
    display: flex;
    justify-content: center;
    flex-direction: column;
    >div{
      text-align: center;
    }
    .amf-title{
      font-size: 16px;
      color: #959595;
      margin-bottom: 20px;
    }
    .amf-icon{
      font-size: 146px;
      opacity: .7;
    }
    .amf-tools{
        >button{
          font-size: 14px;
          
        }
    }
    
`

class PurchaseServiceTips extends React.Component {
    constructor(props) {
        super();
        this.state = {
            visible: false,
        };
    }

    show = () => {
        this.setState({
            visible: true
        })

    }
    hide = () => {
        this.setState({
            visible: false
        })
    }

    render() {

        return (
            <Modal
                width={400}
                visible={this.state.visible}
                footer={null}
                onCancel={this.hide}
            >
                <div style={{textAlign:'center',fontSize:14,padding:'20px 0 10px 0'}}>
                    <Iconfont style={{fontSize:50,color:'red'}}  libname="ckicon" type="tishix"/>
                    <div style={{margin:'5px 0 25px 0'}}>抱歉！您还没有开通
                        <span style={{color:'#FD7926'}}> {this.props.member == 'MEMBER' ? '会员' : '高级会员'} </span>服务
                        {this.props.extra}
                    </div>
                    <Button  type="primary" ghost  onClick={()=>{
                        window.location.href=`${window.location.origin}/admin/mall/products`
                    }}>购买服务</Button>
                </div>
            </Modal>

        )
    }
}
PurchaseServiceTips.defaultProps={
    extra:null,
    member:'MEMBER',
};
export default PurchaseServiceTips;


// WEBPACK FOOTER //
// ./src/containers/PurchaseServiceTips.jsx